import {
  REQUEST_ANALISE_SIMPLE_SIGNAL,
  RESPONSE_ANALISE_SIMPLE_SIGNAL,
  REQUEST_ANALISE_SIGNAL_SIMPLE_FAILURE,
} from "../actions/analiseSignalActions";

import { states } from "./queriesStates";

const initialState = {
  dataAnalyseDataState: states.NOT_REQUESTED,
  deviceId: null,
  headers: [],
  simpleSignals: [],
};

const dataAnalyseReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ANALISE_SIMPLE_SIGNAL:
      return Object.assign({}, state, {
        dataAnalyseDataState: states.REQUEST,
        headers: [],
        simpleSignals: [],
      });

    case RESPONSE_ANALISE_SIMPLE_SIGNAL: {
      return Object.assign({}, state, {
        dataAnalyseDataState: states.READY,
        deviceId: action.data.id,
        headers: action.data.headers,
        simpleSignals: action.data.simpleSignals,
      });
    }
    case REQUEST_ANALISE_SIGNAL_SIMPLE_FAILURE:
      return Object.assign({}, state, {
        dataAnalyseDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default dataAnalyseReducer;
